module.exports = __webpack_public_path__ + "static/img/32.d5b999d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/32.png
// module id = DC0E
// module chunks = 0